module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_keyword-8c9b876fbb51014375c12723fdcc52a9.svg";